export const PRODUCTS = [
  {
    id: "1",
    name: "Stainless Steel Yarn Conditioning Trolley",
    tagline: "Engineered for precision. Built to last decades.",
    description:
      "Our Yarn Conditioning Trolleys are specifically engineered for <strong>XORELLA / SEIGER & ELGI</strong> yarn conditioning plants, manufactured using premium <strong>Stainless Steel 304</strong>. Designed to handle demanding industrial environments, these trolleys ensure durability, stability, and efficient material handling during high-temperature processes.",
    images: [
      "/images/Trolley_5.jpeg",
      "/images/Trolley_6.jpeg",
    ],
    benefits: [
      "Robust SS 304 Construction – Rust-proof and highly durable",
      "Designed for Conditioning Plants – Perfect compatibility with industry systems",
      "High Load Capacity – Built for heavy-duty usage",
      "Smooth Handling – Stable structure for safe and easy movement",
      "Low Maintenance – Long service life with minimal upkeep",
    ],
    competitive_advantages: [
      "Fully stainless steel build (not mixed materials)",
      "Engineered specifically for textile conditioning operations",
      "Reliable performance in continuous industrial use",
      "Customizable size and design for any conditioning room setup",
    ],
  },
  {
    id: "2",
    name: "Ultra High Molecular Stainless Steel Castor Wheel",
    tagline: "Smooth movement. Zero floor damage.",
    description:
      "Our <strong>Ultra High Molecular (UHM)</strong> Castor Wheels are designed for SS yarn conditioning trolleys, offering exceptional performance in <strong>high-temperature environments</strong>. Built with <strong>SS 304</strong> components, including steel balls and grease system, these wheels ensure smooth, long-lasting operation.",
    images: [
      "/images/Castor_Wheel_1.jpeg",
      "/images/Castor_Wheel_2.jpeg",
      "/images/Castor_Wheel_3.jpeg",
    ],
    benefits: [
      "Heat Resistance up to 300°C – Ideal for conditioning processes",
      "Corrosion Resistant – Stainless steel construction prevents rust",
      "Smooth & Balanced Movement of Trolleys – Precision engineering for easy mobility",
      "High Wear Resistance – Long-lasting even under heavy loads",
      "Maintenance-Free Operation – Designed for continuous usage",
    ],
    competitive_advantages: [
      "Complete SS 304 assembly (including internal components)",
      "Superior performance compared to standard castor wheels",
      "Built for extreme durability and industrial reliability",
    ],
  },
  {
    id: "3",
    name: "Stainless Steel Lycra Bobbin Trolley (Tapa Trolley)",
    tagline: "Precision storage for every bobbin.",
    description:
      "Our <strong>Stainless Steel Perforated Trolley/Basket</strong> is designed for efficient material handling in textile and industrial environments, especially suitable for yarn conditioning and storage applications. Manufactured using high-quality <strong>Stainless Steel 304</strong>, it ensures strength, hygiene, and long-lasting performance under demanding conditions. The <strong>perforated design</strong> allows proper airflow and heat circulation, making it ideal for processes where ventilation is critical.",
    images: [
      "/images/Tapa_1.jpeg",
      "/images/Tapa_2.jpeg",
      "/images/Tapa_3.jpeg",
    ],
    benefits: [
      "SS 304 Construction – Corrosion-resistant, rust-proof, and highly durable",
      "Perforated Design – Enables airflow for efficient conditioning and drying",
      "High Load Capacity – Strong structure for heavy industrial use",
      "Hygienic & Easy to Clean – Ideal for textile and clean environments",
      "Smooth Mobility (with castors) – Easy handling across factory floors",
      "Long Service Life – Built for continuous usage with minimal wear",
    ],
    competitive_advantages: [
      "Fully stainless steel fabrication (no compromise on material quality)",
      "Designed specifically for textile and conditioning plant requirements",
      "Precision-built for strength, balance, and ventilation efficiency",
      "Customizable sizes and designs as per client needs",
    ],
  },
];

export const TESTIMONIALS = [
  {
    id: "1",
    name: "Rajesh Kumar",
    role: "Plant Manager",
    company: "Vardhman Textiles",
    quote:
      "We've been using Divya Enterprises trolleys for 8 years. The stainless steel quality is unmatched — zero corrosion even in our high-humidity conditioning rooms. Their after-sales support is exceptional.",
    avatar: "",
  },
  {
    id: "2",
    name: "Sunil Mehta",
    role: "Operations Head",
    company: "Welspun India",
    quote:
      "The castor wheels from Divya Enterprises transformed our factory floor operations. Noise reduction was immediate, and we haven't replaced a single wheel in 3 years. Remarkable durability.",
    avatar: "",
  },
  {
    id: "3",
    name: "Priya Sharma",
    role: "Procurement Director",
    company: "Trident Group",
    quote:
      "We compared 12 suppliers before choosing Divya Enterprises. Their 25+ years of expertise shows in every product. Custom sizing, on-time delivery, and pricing that makes sense for bulk orders.",
    avatar: "",
  },
];

export const PARTNERS = [
  { id: "1", name: "Vardhman Textiles", logo: "/images/logo/Vardhman_Logo.svg.png" },
  { id: "2", name: "Nitin Spinners", logo: "/images/logo/Nitin_Spinners_Ltd._1674475120.jpeg" },
  { id: "3", name: "RSWM", logo: "/images/logo/RSWM.png" },
  { id: "4", name: "Ginni Filaments", logo: "/images/logo/ginni.webp" },
  { id: "5", name: "Kanchan India", logo: "/images/logo/kanchan_india_logo.png" },
  { id: "6", name: "Lagnam", logo: "/images/logo/lagnam.jpeg" },
  { id: "7", name: "DCM", logo: "/images/logo/dcm.jpeg" },
  { id: "8", name: "ST & Co", logo: "/images/logo/st&co.jpeg" },
  { id: "9", name: "Sudiva", logo: "/images/logo/Sudiva.jpeg" },
  { id: "10", name: "Sutlej Textiles", logo: "/images/logo/sutlej.jpeg" },
];

export const COMPANY_INFO = {
  name: "Divya Enterprises",
  tagline: "Precision Engineering Since 1999",
  years_in_business: 25,
  phone: "+91 9911414981",
  email: "divyamukesh_mukeshdivya@yahoo.co.in",
  description:
    "Leading manufacturer of premium stainless steel yarn conditioning trolleys and ultra high molecular pure castor wheels. Trusted by India's top textile companies for over 25 years.",
  stats: {
    years: "25+",
    clients: "50+",
    products_delivered: "20,000+",
    cities: "10+",
  },
};
